<template>
  <ul class="mt-5 text-xs text-gray-500">
    <li class="flex align-middle">
      <CheckIcon class="mr-2 h-4 w-4 text-orange-400" aria-hidden="true" /> 0% Ausgabeaufschlag
    </li>
    <li class="flex align-middle">
      <CheckIcon class="mr-2 h-4 w-4 text-orange-400" aria-hidden="true" /> 100% der
      Vertriebsgebühren als Cashback zurück*
    </li>
    <li class="flex align-middle">
      <CheckIcon class="mr-2 h-4 w-4 text-orange-400" aria-hidden="true" /> Analytische, faire &
      günstige Portfolioberatung
    </li>
    <li class="flex align-middle">
      <CheckIcon class="mr-2 h-4 w-4 text-orange-400" aria-hidden="true" /> Effiziente & günstige
      ETF-Portfolios
    </li>
    <li class="flex align-middle">
      <CheckIcon class="mr-2 h-4 w-4 text-orange-400" aria-hidden="true" /> Über 10.000 Fonds und
      ETFs
    </li>
    <li class="flex align-middle">
      <CheckIcon class="mr-2 h-4 w-4 text-orange-400" aria-hidden="true" /> Etablierte
      EU-Depotbanken
    </li>
    <small class="mt-3 block">* Es fällt eine Service-Gebühr an</small>
  </ul>
</template>

<script setup lang="ts">
import { CheckIcon } from '@heroicons/vue/20/solid'
</script>
